






























import Vue from 'vue'
import Component from 'vue-class-component'
import RespondecoPosts from '../../post/components/posts.vue'
import { Post } from '../../post/models/post'
import { activeUser, userIsAuthenticated } from '@/shared/utils/user'
import { PostUpdate } from '../../post/models/post-update'
import { ProjectPostDataSource } from '@/business/project/project-post-data-source'
import { DataSourcePaginator } from '@/shared/models/data/data-source-paginator'
import { Hooks } from '@/shared/interfaces/hooks'
import UnifyButton from '@/shared/components/unify/unify-button.vue'
import { Injector } from '@/config/dependency-injection'
import { ProjectModule } from '@/business/project/store/project-module'

@Component({
  name: 'project-posts',
  components: { UnifyButton, RespondecoPosts },
})
export default class ProjectPosts extends Vue implements Hooks {
  private dataSource!: ProjectPostDataSource
  private paginator!: DataSourcePaginator<Post>
  private projectModule = Injector.get(ProjectModule)

  public get hasMorePosts(): boolean {
    return this.dataSource.hasMorePosts()
  }

  public get isLoadingPosts(): boolean {
    return this.dataSource.isLoading()
  }

  public get isPartner(): boolean {
    const user = activeUser()

    return this.projectModule.data.project.partners.some(
      partner => user.organisation.id === partner.organisation.id
    )
  }

  public get posts(): Post[] {
    return this.dataSource.items
  }

  public get showPosts(): boolean {
    return this.posts.length > 0 || userIsAuthenticated()
  }

  constructor() {
    super()

    this.dataSource = new ProjectPostDataSource()
    this.paginator = new DataSourcePaginator(this.dataSource)
  }

  public mounted() {
    this.paginator.initialize()
  }

  public activeUserCanEditPost(post: Post): boolean {
    return activeUser().id === post.author.id
  }

  public createPost(post: PostUpdate): Promise<Post> {
    return this.dataSource.createPost(post)
  }

  public deletePost(post: Post): Promise<Post> {
    return this.dataSource.deletePost(post)
  }

  public loadMorePosts(): void {
    this.paginator.next().update()
  }

  public updatePost(post: Post): Promise<Post> {
    return this.dataSource.updatePost(post)
  }
}
